<template>
  <TableBodyRow
    :thead="thead"
    class="combosrowopponnet gw_table_body_row_hoverable"
  >
    <TableBodyCell
      thKey="summary_idx"
      class="gw_table_body_cell_sticky"
    >
      <CardSymbols
        :colorDefault="true"
        :cardsIds="item.id"
        style="--size: 1rem"
      />
    </TableBodyCell>
    <TableBodyCell thKey="range">{{
      numFixedUnit(item.players[player].range, 'range')
    }}</TableBodyCell>
    <TableBodyCell thKey="ev">
      <!-- {{ numFixed(item.opponent.ev, 2) }} -->
      <div
        style="line-height: 0.8"
        v-html="
          getEvHtml({
            ...bettingInfo,
            ignoreIcmEvIntercept: true,
            ev: item.players[player].ev,
            player: 'opponent',
          })
        "
      />
    </TableBodyCell>
    <TableBodyCell thKey="eq">
      <div v-if="showFlopContent">{{ numFixedUnit(item.players[player].eq * 100, 'eq') }}</div>
    </TableBodyCell>
    <TableBodyCell thKey="eq">
      <div v-if="showFlopContent">{{ numFixedUnit(item.players[player].eqr * 100, 'eqr') }}</div>
    </TableBodyCell>
    <TableBodyCell
      style="order: 99; --padding-td: 0"
      class="role_spacer"
    >
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import CardSymbols from '@/components/CardSymbols/CardSymbols'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'CombosTableRowOpponent',
  components: {
    TableBodyRow,
    TableBodyCell,
    CardSymbols,
  },
  mixins: [table_mix, float_mix],
  props: {
    thead: Object,
    item: Object,
    player: String,
    index: Number,
    showFlopContent: Boolean,
    bettingInfo: Object,
  },
}
</script>
